import { createReducer } from "@reduxjs/toolkit";

import { BaseFilter } from "@shared/interfaces";

import * as actions from "./actions";
import { CasesStateType } from "../interface";
import { CASE_DOCUMENT_SYNC_KEYS } from "../constants/caseDocuments";

export const defaultFilter: BaseFilter = {
  page: 0,
  limit: 50,
  search: "",
};

export const initialState: CasesStateType = {
  cases: [],
  case: null,
  caseDocuments: [],
  medicalRecordsResult: null,
  casesTotal: null,
  filter: { ...defaultFilter },
};

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(actions.setProcessingCaseId, (state, action) => {
    state.processingCaseId = action.payload;
  });
  builder.addCase(actions.getCasesList.success, (state, action) => {
    const { rows, count, clear } = action.payload;
    state.cases = !clear ? [...state.cases, ...rows] : [...rows];
    state.casesTotal = count;
  });
  builder.addCase(actions.getCasesStatuses.success, (state, action) => {
    const statusesByCaseId = new Map(action.payload.map((caseStatus) => [caseStatus.id, caseStatus]));

    state.cases = state.cases.map((caseObj) => {
      const caseStatus = statusesByCaseId.get(caseObj.id);

      return caseStatus ? { ...caseObj, ...caseStatus } : caseObj;
    });
  });
  builder.addCase(actions.getCase.success, (state, action) => {
    if (state.case?.id !== action.payload?.id) {
      state.medicalRecordsResult = null;
    }
    state.case = action.payload;
    state.caseDocuments = action.payload?.case_documents ?? [];
  });
  builder.addCase(actions.restartProcessingCase.success, (state, action) => {
    state.case = action.payload.element;
    state.caseDocuments = action.payload.element.case_documents ?? [];
  });
  builder.addCase(actions.getCaseDocuments.success, (state, action) => {
    state.caseDocuments = action.payload;
  });
  builder.addCase(actions.parseCaseDocument.success, (state, action) => {
    state.caseDocuments = action.payload;
    state.medicalRecordsResult = null;
  });
  builder.addCase(actions.retryCaseDocument.success, (state, action) => {
    state.caseDocuments = action.payload;
    state.medicalRecordsResult = null;
  });
  builder.addCase(actions.removeCaseDocumentSuccess, (state, action) => {
    state.caseDocuments = action.payload.case_documents ?? [];
    state.medicalRecordsResult = null;
  });
  builder.addCase(actions.chooseMedicalFieldValueSuccess, (state, action) => {
    state.caseDocuments = action.payload.case_documents ?? [];
    state.medicalRecordsResult = null;
  });
  builder.addCase(actions.verifyMedicalFieldSuccess, (state, action) => {
    state.caseDocuments = action.payload.case_documents ?? [];
    state.medicalRecordsResult = null;
  });
  builder.addCase(actions.getMedicalRecordsResult.success, (state, action) => {
    state.medicalRecordsResult = action.payload;
  });
  builder.addCase(actions.syncCaseDocumentFields, (state, action) => {
    if (!state.case || state.case.id !== action.payload.id) return;

    Object.assign(state.case, Object.fromEntries(CASE_DOCUMENT_SYNC_KEYS.map((key) => [key, action.payload[key]])));
  });
  builder.addCase(actions.setFilter, (state, action) => {
    state.filter = action.payload || { ...defaultFilter };
  });
  builder.addCase(actions.clearCasesList, (state) => {
    state.cases = [];
    state.casesTotal = 0;
  });
});

export { reducer as CasesReducer };
